import axios from 'axios'
import Toastify from 'toastify-js'
import "toastify-js/src/toastify.css"
import { find, findAll } from "../utils/dom";

const Newsletter = () =>{
	const modalNewsLetter = findAll(`[js-modal="newsletters"]`);
	if(!modalNewsLetter) return;

	const showToastify = (message, opts) => {
		Toastify({
			duration: 3000,
			position: "center",
			style: { background: "rgba(193, 255, 129)", fontSize: "18px", color: "rgba(45, 71, 120, 1)" },
			text: message,
			...opts
		}).showToast();
	}


	const $ = {
		form: findAll(`[js-form="newsletters"]`)
	}


	$.form?.forEach((form_item)=>{
		form_item?.addEventListener("submit", (e) =>{
			e.preventDefault();

			const form = new FormData(e.target);
			const buttonSubmit = e.target.querySelectorAll(`button[type='submit']`);


			disabledBtn(buttonSubmit);

			let form_data;

			form_data = {
				email: form.get('newsletters-email'),
			}

			const url = "/newsletter/"
			axios.post(url, form_data)
				.then((response) => showMessage(response,buttonSubmit, e.target))
				.catch((response) => showMessage(response,buttonSubmit, e.target));

		})
	})


	function showMessage(response, btnFormContato, form) {
		const isSuccess = response.data && response.data.message;
		const message = response.data ? response.data.message : response.message

		//message = isSuccess ? 'Mensagem enviada com sucesso! Obrigado!' : 'Oops, aconteceu algo de errado! Tente de novo!'


		const backgroundColor = isSuccess ? "rgba(193, 255, 129)" : "rgba(233, 44, 44)";
		const textColor = isSuccess ? "rgba(45, 71, 120, 1)" : "white";

		showToastify(message, {
			style: {
				background: backgroundColor,
				color: textColor,
				fontSize: "18px",
				borderRadius: "8px"
			},
		});
		form?.reset()
		setTimeout(enabledBtn(btnFormContato), 1000)
	}

	function disabledBtn(btnFormContato) {
		btnFormContato.forEach((btn) => {
			btn.disabled = true
			btn.classList.add("disabled")
		})
	}

	function enabledBtn(btnFormContato) {
		btnFormContato.forEach((btn) => {
			btn.disabled = false
			btn.classList.remove("disabled")
		})
	}


}

export default Newsletter;